import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaMagnifyingGlass } from "react-icons/fa6";
import api from '../../api/manage_database/ConverterReq';
import SelectConverter from '../../components/SelectConverter';
import BackButton from "../../components/BackButton";
import { toast } from "sonner";


const ConverterChoice = () => {

    const [Converters, setConverters] = useState([]);
    const [selectedConverter, setSelectedConverter] = useState('');
    
    const navigate = useNavigate();

    const handleView = () => {
        if (selectedConverter === '') {
            toast.error('Choose available converter!')
            return
        } else {
            navigate(`../record/${selectedConverter}`)
        }
    }

    useEffect(() => {
        const fetchConverters = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setConverters(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchConverters();
    }, []);

    return (
        <div className='converter-choice-container'>
            <h2 className='converter-choice-title'>Converter</h2>
            <div className='converter-choice-card'>
                <div className='converter-choice-label-select-wrapper'>
                    <label
                        htmlFor='converter-select'
                        className='bold-label'
                    >
                        Converter:
                    </label>
                    <SelectConverter
                        Converters={Converters}
                        selectedConverter={selectedConverter}
                        setSelectedConverter={setSelectedConverter}
                    />
                </div>
                <button
                    className='converter-choice-button'
                    onClick={handleView}>View &nbsp; <FaMagnifyingGlass /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default ConverterChoice;